import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Map } from "immutable";
import {
    Row,
    Col,
    Layout,
} from "antd";
import { List } from "immutable";
import { DOCUMENT_CURRENT_STATUS } from "constants/enums";
import {
    uploadDocument,
    uploadDocuments,
    updateDocument,
    invalidateDocument,
    requestDocuments,
    validateDocument,
    parseDocument,
    sendRequest,
    addRequestRemarks
} from "store/actions";
import { PermissionContextManager } from "hocs/permission-context-manager";
import { UI_PERMISSIONS, STATE_STATUS } from "constants/index";
import "styles/document-review.css";
import DocumentViewList from "../case-details-tabs/document-view-list";
import PaymentProgramSignzyDataForm from "../../forms/paymentProgramSignzyForm";
import { updateDocumentStatus } from "../../modules/companies/actions";
import { getDataFromQueryString } from "../../utils";


class PPDocumentReviewTab extends React.PureComponent {
    state = {
        selectedFilePath: null,
        selectedFileType: null,
        selectedFile: null,
        fileName: null,
        docMaster: new List([]),
        showRequestedRemarks: false,
        requestedRemarks: null
    };

    componentDidMount() {
        this.setState({
            showParsedData: this.getRenderFile()
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.updateDocumentSignzyStatus === STATE_STATUS.FETCHING && this.props.updateDocumentSignzyStatus === STATE_STATUS.FETCHED) {
            this.props.fetchPaymentProgramActionDetails();
        }
        if (prevProps.caseCheckListStatus === STATE_STATUS.FETCHING && this.props.caseCheckListStatus === STATE_STATUS.FETCHED) {
            setTimeout(() => {
                this.setState({
                    showParsedData: this.props.files.find(_ => _.documents[0].id === (this.state.selectedFile && this.state.selectedFile.id))
                });
            }, 1000);
        }
        if (prevProps.parseDocumentStatus === STATE_STATUS.FETCHING && this.props.parseDocumentStatus === STATE_STATUS.FETCHED) {
            let data = this.state.selectedFile && this.props.files.find(_ => _.documents[0].id === (this.state.selectedFile && this.state.selectedFile.id));
            data.signzy_data.data = this.props.signzyParsedData.getIn([this.props.companyId, "data", this.getRenderFile().id]).toJS().data || data.signzy_data.data;
            this.setState({
                showParsedData: data
            }, this.forceUpdate());
        }
    }

    viewDoc = file => {
        let document = file;
        const filePath = document.file;
        const fileNameArr = (document && document.file.split("/").reverse()[0].split(".")) || [];
        const fileType = fileNameArr.reverse()[0];
        let parsedData = this.getRenderFile(document);
        this.setState(
            {
                selectedFileType: document.file_mime_type && document.file_mime_type !== "application/x-empty" ? document.file_mime_type : fileType,
                selectedFilePath: filePath,
                selectedFile: document,
                fileName: document.file_name,
                showParsedData: parsedData

            },
            () => {
                this.forceUpdate();
            }
        );
    };

    updateDocument = (action, file, address = {}, bankAccount = {}, formFields = {}, remarks = "") => {
        let data = {
            company_document_id: file.document_option === "Aadhar - Back" ? file.front_details.documents[0].company_document_id : file.company_document_id,
            document_id: file.document_id,
            document_option: file.document_option === "Aadhar - Back" ? file.front_details.document_option : file.document_option,
            verification_status: action,
            document_master_id: file.document_option === "Aadhar - Back" ? file.front_details.documents[0].id : file.documents[0].id,
            action_detail_id: this.props.action_detail_id,
            remarks: remarks || undefined,
            aadhar_back_keys: file.document_option === "Aadhar - Back" ?
                {
                    company_document_id: file.company_document_id,
                    document_master_id: file.documents[0].id
                } : undefined,
            signzy_data: {
                ...bankAccount?.ifsc_code || null,
                account_holder_name : bankAccount?.account_holder_name || undefined,
                account_number: bankAccount?.account_number || undefined,
                ...address,
                ...formFields,
                city: address?.city?.id ? address?.city : address?.city?.name,
                state: address?.state?.id ? address.state : address?.state?.name,
                dob: formFields?.dob?.format("YYYY-MM-DD") || formFields?.dob_pan?.format("YYYY-MM-DD"),
                date_of_incorporation: formFields?.date_of_incorporation?.format("YYYY-MM-DD") || undefined
            }
        };
        switch (action) {
        case "Rejected":
            this.props.updateDocumentStatus(this.props.companyId, data);
            break;
        case "Approved":
            this.props.updateDocumentStatus(this.props.companyId, data);
            break;
        }
    };

    addRequestedRemark = (docId, document) => {
        this.setState({
            selectedFile: document,
            showRequestedRemarks: true,
            requestedRemarks: document.request_remarks
        });
    };

    onKeyUp = e => {
        if (this.state.selectedFile) {
            const keyCode = e.keyCode;

            const currentFileIndex = this.props.files.findIndex(
                _ => _ && _.id === this.state.selectedFile.id
            );

            if (keyCode === 38) {
                if (currentFileIndex > 0) {
                    this.viewDoc(this.props.files
                        .filter(_ => _.document_status !== DOCUMENT_CURRENT_STATUS.get("Requested"))
                        .sort((a, b) => {
                            if (a.id > b.id) {
                                return -1;
                            }
                            if (a.id < b.id) {
                                return 1;
                            }
                            if (a.id === b.id) {
                                return 0;
                            }
                        })
                        .get(currentFileIndex - 1));
                }
            }
            if (keyCode === 40) {
                if (currentFileIndex < this.props.files.size - 1) {
                    this.viewDoc(this.props.files
                        .filter(_ => _.document_status !== DOCUMENT_CURRENT_STATUS.get("Requested"))
                        .sort((a, b) => {
                            if (a.id > b.id) {
                                return -1;
                            }
                            if (a.id < b.id) {
                                return 1;
                            }
                            if (a.id === b.id) {
                                return 0;
                            }
                        })
                        .get(currentFileIndex + 1));
                }
            }
        }
    };

    invalidateDoc = () => {
        this.props.invalidateDocument(
            this.props.companyId,
            this.state.selectedFile && this.state.selectedFile.id,
            this.state.selectedFile
                .set("remarks", this.state.remarks)
                .set("file_name", this.state.fileName),
            this.props.caseId
        );
    };

    changeName = file => {
        this.props.validateDocument(
            this.props.companyId,
            null,
            file
        );
    };

    getDocumentType = () => {
        if (
            this.state.fileName &&
            this.state.fileName.toLowerCase().includes("adhar")
        ) {
            return "aadhaar";
        }
        if (
            this.state.fileName &&
            this.state.fileName.toLowerCase().includes("pan")
        ) {
            return "pan";
        }
        return null;
    };

    openRequestModal = () => {
        this.setState({
            requestModal: true
        });
    };


    parseDocumentRequest = (file, docType) => {
        this.props.parseDocument(
            file,
            docType.toLowerCase()
        );
    };

    requestDocSearch = event => {
        this.setState({
            requestDocSearchQuery: event.target.value
        });
    }

    filterDocumentCategory = (doc) => {
        return this.state.requestDocSearchQuery ? doc.document_name && doc.document_name.toLocaleLowerCase().includes(this.state.requestDocSearchQuery.toLocaleLowerCase()) : true;
    }

    createNewDocument = (blob) => {

        let newBlob = blob;
        const file = new File([newBlob], this.state.selectedFile.file_name, { type: blob.type, lastModified: new Date() });
        const formData = new FormData();
        formData.append("file", file);
        formData.append("company", this.props.companyId);
        formData.append("file_name", this.state.selectedFile.file_name);
        formData.append("parent_document_master", this.state.selectedFile.id);
        // this.props.uploadDocument(this.props.caseId, this.props.companyId, formData);
        // this.updateDocument("DELETE", this.state.selectedFile.set("is_active", false), null, null);
    }

    closeRequestRemarksModal = () => {
        this.setState({
            showRequestedRemarks: false,
            requestedRemarks: null
        });
    }

    getRenderFile = (document = {}) => {
        return (this.state.selectedFile || Object.keys(document).length) && this.props.files.find(_ => _.documents[0].id === (Object.keys(document).length ? document.id : (this.state.selectedFile && this.state.selectedFile.id)));
    }

    getParsedDataShow = () => {
        return this.getRenderFile() && this.props.signzyParsedData.getIn([this.props.companyId, "data", this.getRenderFile().id], Map());
    }

    get filterCurrentCase(){
        const { ppAssociates} = this.props;
        return ppAssociates.filter(_ => Number(_.onboarding_id) === Number(this.props.action_detail_id));
    }

    get isEditAccess(){
        if (Number(getDataFromQueryString("ordering")) === 1 || Number(getDataFromQueryString("ordering")) === 3) {
            return false;
        }
        if ((this.props.permissions.size && this.props.permissions.get("page_dbt_bulk_assign"))) {
            return true;
        } else if (this.props.permissions.get("page_dbt_edit")) {
            return (this.filterCurrentCase.size && this.filterCurrentCase.getIn([0, "open_task_this_user", "id"], "") === this.props.userDetails.id);
        }
        return false;
    }
    render() {
        const recreditViewOnlyPermission = this.props.caseDetail?.toJS().current_case_task?.some(el=>el.this_stage === 42);
        return (
            <React.Fragment>
                <div tabIndex={0} onKeyDown={this.onKeyUp}>
                    <Layout className={"doc-review-layout"}>
                        <Layout.Content>
                            <Row
                                className={
                                    "d-flex h-100 p-5 base-layout-row"
                                }>
                                <Col
                                    span={7}
                                    className={"doc-list p-5"}>
                                    <DocumentViewList
                                        hideRequestDocs
                                        showActionButtons={Number(getDataFromQueryString("ordering")) === 3}
                                        files={List(this.props.files.toJS().sort((a, b) => a.serial_no - b.serial_no))}
                                        viewDoc={this.viewDoc}
                                        selectedFileId={
                                            this.state.selectedFile &&
                                            this.state.selectedFile.id
                                        }
                                        stageId={this.props.stageId}
                                        addRequestedRemark={this.addRequestedRemark}
                                        companyId={this.props.companyId}
                                        uploadFiles={this.props.uploadDocuments.bind(
                                            null,
                                            this.props.caseId,
                                            this.props.companyId
                                        )}
                                        filesStatus={
                                            this.props.filesStatus
                                        }
                                        changeName={this.changeName}
                                        openRequestModal={
                                            this.openRequestModal
                                        }
                                        noDocumentDeletePerm={this.props.noDocumentDeletePerm}
                                        categoryList={["Aadhar Card", "Pan Card", "Gst", "Company Pan"]}
                                        docMasterListStatus={
                                            this.props
                                                .docMasterListStatus
                                        }
                                        fetchFiles={this.handleFilesFetch}
                                        recreditViewOnlyPermission={recreditViewOnlyPermission}
                                    />
                                </Col>
                                <Col span={17}>
                                    <PaymentProgramSignzyDataForm
                                        editPermission={this.isEditAccess}
                                        hideDocumentActions
                                        hideSignzyButton={this.props.files.size && this.props.files.filter(_ => ["Aadhar-Back" ,"Aadhar-Front" ].includes(_.label) && _.status === "Approved").size}
                                        activeAssociate={this.state.activeAssociate}
                                        fileType={
                                            this.state.selectedFileType
                                        }
                                        filePath={
                                            this.state.selectedFilePath
                                        }
                                        file={this.state.showParsedData}
                                        associates={
                                            this.props.associates
                                        }
                                        docMasterList={
                                            this.state.docMaster
                                        }
                                        companyId={this.props.companyId}
                                        addressesList={
                                            this.props.addressesList
                                        }
                                        updateDocument={this.updateDocument}
                                        parseData={this.parseDocumentRequest}
                                        createNewDocument={this.createNewDocument}
                                    />
                                </Col>
                            </Row>
                        </Layout.Content>
                    </Layout>
                </div>
            </React.Fragment>
        );
    }
}

PPDocumentReviewTab.propTypes = {
    caseId: PropTypes.number,
    companyId: PropTypes.number,
    files: PropTypes.array,
    filesStatus: PropTypes.string,
    uploadDocuments: PropTypes.func,
    updateDocument: PropTypes.func,
    associatesStatus: PropTypes.string,
    associates: PropTypes.array,
    bankAccounts: PropTypes.array,
    docMasterListStatus: PropTypes.string,
    docMasterList: PropTypes.array,
    validateDocument: PropTypes.func,
    invalidateDocument: PropTypes.func,
    updateCompanySingleAssociate: PropTypes.func,
    requestDocuments: PropTypes.func,
    addressesList: PropTypes.object,
    parseDocument: PropTypes.func,
    panParsedData: PropTypes.object,
    aadhaarParsedData: PropTypes.object,
    sendRequest: PropTypes.func,
    uploadDocument: PropTypes.func,
    addRequestRemarks: PropTypes.func,
    stageId: PropTypes.number,
    noDocumentDeletePerm: PropTypes.bool,
    updateDocumentStatus: PropTypes.func,
    action_detail_id: PropTypes.number,
    signzyParsedData: PropTypes.object,
    updateDocumentSignzyStatus: PropTypes.string,
    parseDocumentStatus: PropTypes.string,
    checklistStatus: PropTypes.string,
    fetchPaymentProgramActionDetails: PropTypes.func,
    caseCheckListStatus: PropTypes.string,
    permissions: PropTypes.object,
    userDetails: PropTypes.object,
    ppAssociates: PropTypes.object,
    caseDetail: PropTypes.object,

};

const mapStateToProps = (state, props) => {
    const currentTab = state.paymentProgramDetails.get("current_tab") || "1";
    return {
        signzyParsedData: state.documents.getIn(["company_documents"]),
        uploads: state.documents.getIn(["uploads", props.companyId]),
        caseDetail: state.caseDetails.getIn([Number(props.caseId), "data"]),
        docMasterListStatus: state.documents.getIn([
            "documentsMasterList",
            "status"
        ]),
        docMasterList: state.documents.getIn(["documentsMasterList", "data"]),
        associates: state.companies.getIn([
            props.companyId,
            "data",
            "associates"
        ], Map({})),
        associatesStatus: state.documents.getIn([
            props.companyId,
            "status",
            "associatesStatus"
        ], STATE_STATUS.UNFETCHED),
        addressesList: state.companies.getIn([
            props.companyId,
            "data",
            "addresses"
        ]),
        bankAccounts: state.companies.getIn([
            props.companyId,
            "data",
            "bank_accounts"
        ]),
        panParsedData: state.documents.getIn([
            "parsedData",
            props.companyId,
            "pan"
        ]),
        aadhaarParsedData: state.documents.getIn([
            "parsedData",
            props.companyId,
            "aadhaar"
        ]),
        noDocumentDeletePerm: state.user.getIn(["permissions", "cannot_delete_document"]),
        updateDocumentSignzyStatus: state.companyLosProfiles.get("updateDocumentSignzyStatus") || STATE_STATUS.UNFETCHED,
        parseDocumentStatus: state.documents.get("parseDocumentStatus") || STATE_STATUS.UNFETCHED,
        checklistStatus: state.paymentProgramDetails.getIn([currentTab, "status"]) || STATE_STATUS.UNFETCHED,
        caseCheckListStatus: state.paymentProgramDetails.getIn(["caseCheckListStatus"]) || STATE_STATUS.UNFETCHED,
        permissions: state.user.get("permissions"),
        userDetails: state.user.get("data"),
        ppAssociates: state.paymentProgramDetails && state.paymentProgramDetails.getIn([currentTab, "data"]),

    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateDocument,
            uploadDocuments,
            invalidateDocument,
            validateDocument,
            requestDocuments,
            parseDocument,
            sendRequest,
            uploadDocument,
            addRequestRemarks,
            updateDocumentStatus
        },
        dispatch
    );

const WrappedComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(PPDocumentReviewTab);
export default PermissionContextManager({
    permission: UI_PERMISSIONS.PAGE_DBT_EDIT,
    propsPermissions: {
        DOCUMENTS_EDIT: UI_PERMISSIONS.DOCUMENTS_EDIT
    }
})(WrappedComponent);
